import React from 'react'
import PropTypes from 'prop-types'
import EditForm from '../edit_form'
import PoolCover from 'components/pool_cover'

class EditDescription extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
  }

  render() {
    return (
      <EditForm {...this.props}>
        <PoolCover fields={this.props.fields} />
      </EditForm>
    )
  }
}

export default EditDescription
